// Validation check fields for TemplateBusinessRole
export const validationCheckFields = [
    { key: 'validation_TemplateBusinessRole', labelKey: 'TemplateBusinessRole' },
    { key: 'validation_FriendlyName', labelKey: 'FriendlyName' },
    { key: 'validation_Action', labelKey: 'Action' },
    { key: 'validation_HighLevelClassification', labelKey: 'HighLevelClassification' },
    { key: 'validation_OwnersToAdd', labelKey: 'OwnersToAdd' },
    { key: 'validation_OwnersToRemove', labelKey: 'OwnersToRemove' },
    { key: 'validation_DomainAttributesToAdd', labelKey: 'DomainAttributesToAdd' },
    { key: 'validation_DomainAttributesToRemove', labelKey: 'DomainAttributesToRemove' },
    { key: 'validation_ActionInsertConflict', labelKey: 'ActionInsertConflict' },
    { key: 'validation_ActionUpdateConflict', labelKey: 'ActionUpdateConflict' },
    { key: 'validation_LastFailed', labelKey: 'LastFailed' },
    { key: 'validation_LastFailedError', labelKey: 'LastFailedError' },

]

